import React from "react"
import {
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import axios from "axios"
import * as Icon from "react-feather"
import {connect} from "react-redux";
import { history } from "@src/history"
import { logout, waxLogin, anchorLogin, oreLogin, checkIfLoggedIn, wombatLogin }  from '@store/actions/auth/loginActions';
import AnchorLink from 'anchor-link'
import AnchorLinkBrowserTransport from 'anchor-link-browser-transport'

import "./custom.scss";
import SweetAlert from "react-bootstrap-sweetalert";
import { withUAL } from 'ual-reactjs-renderer';
import { OreId} from "oreid-js";
import { WebPopup } from "oreid-webpopup";

const handleNavigation = (e, path) => {
  e.preventDefault();
  history.push(path)
}
var userData;
const oreIdOptions = {
  appName: "ORE ID Login",
  appId: process.env.REACT_APP_OREID_APP_ID,
  plugins: { popup: WebPopup() }
}
var oreId = new OreId(oreIdOptions);
oreId.init()

const UserDropdown = props => {
  return (
      <div></div>
  )
}
class NavbarUser extends React.PureComponent {
    state = {
        showSelectLogin:false
    }
    componentDidMount = async() => {
      if (oreId.auth.user._accountName) {
        userData = await oreId.auth.user?.getData()
      }
      this.loginAnchor()
    }
    componentDidUpdate = async(prevProps) => {
        oreId = new OreId(oreIdOptions);
        if (oreId.auth.user._accountName) {
          userData = await oreId.auth.user?.getData()
        }
        if(this.props.ual.activeUser != prevProps.ual.activeUser){
            if(this.props.ual.activeUser.wax){
                this.props.waxLogin(this.props.ual.activeUser.pubKeys, this.props.ual?.activeUser?.accountName, true, ()=>{
                    this.setState({showSelectLogin:false})
                });
            }else if(this.props.ual.activeUser.session){
                let pubKeys = [this.props.ual.activeUser.session.publicKey.toString()];
                let userAccount = this.props.ual?.activeUser?.accountName;
                this.props.anchorLogin(pubKeys, userAccount, null, ()=>{
                    this.setState({showSelectLogin:false})
                });
            }else if(this.props.ual.activeUser.scatter){
              let pubKeys = [this.props.ual.activeUser.keys.toString()];
              let userAccount = this.props.ual?.activeUser?.accountName;
              console.log('wombat 1')
              window.ual = this.props.ual?.activeUser;
              this.props.wombatLogin(pubKeys, userAccount, ()=>{
                  this.setState({showSelectLogin:false})
              });
            }
        }
        if (userData) {
          let pubKeys = [userData?.chainAccounts[0].permissions[0].publicKey, userData?.chainAccounts[1].permissions[0].publicKey];
          let userAccount = userData?.accountName;
          this.props.oreLogin(pubKeys, userAccount, () => {
            this.setState({ showSelectLogin: false })
          });
        } 
    }
    loginAnchor = async() => {
        const transport = new AnchorLinkBrowserTransport()
        const link = new AnchorLink({
            transport,
            chains: [
                {
                    chainId: '1064487b3cd1a897ce03ae5b6a865651747e2e152090f99c1d19d44e01aea5a4',
                    nodeUrl: window.selected_rpc,
                }
            ],
        })
        const identity = await link.login('battleminers')
        const {session} = identity
        let pubKeys = [session.publicKey.toString()];
        let userAccount = session.auth.actor.toString();
        window.identity = identity;
        console.log('anchorLogin2', identity)
        this.props.anchorLogin(pubKeys, userAccount, identity, ()=>{
            this.setState({showSelectLogin:false})
        });
    }
    loginWax = async () => {
        const userAccount = await this.props.wax.login();
        const pubKeys = this.props.wax.pubKeys;
        /*var isAutoLoginAvailable = await window.wax.isAutoLoginAvailable();
        this.props.waxLogin(pubKeys, userAccount, isAutoLoginAvailable, ()=>{
            this.setState({showSelectLogin:false})
        });*/
    }

  selectLoginPlatform = () => {
      this.setState({showSelectLogin:true});
  }
  render() {
      let accountName = this.props.ual?.activeUser?.accountName;
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        {window.location.pathname !== '/shadow_depths' && <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link">
            <div className="user-nav">
              <span className="user-name m-0">
                {accountName}
              </span>
              <span className="user-status">{''}</span>
            </div>
            <span data-tour="user">
                {!accountName && <div className="login-btn-block">
                    <Button color="login" style={{backgroundColor:'black !important'}} type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.ual.showModal();
                        }}>
                      Login
                    </Button>
                </div>}
            </span>
          </DropdownToggle>
          {accountName && <UserDropdown {...this.props} />}
        </UncontrolledDropdown> }
        <SweetAlert title="Login"
            show={this.state.showSelectLogin}
            showConfirm={false}
            closeOnClickOutside={true}
            onConfirm={()=>{}}
            onCancel={()=>{
                this.setState({showSelectLogin:false})
            }}
            >
            <button className="btn login_btn cloud" onClick={this.loginWax}>Wax Cloud Wallet</button>
            <button className="btn login_btn anchor" onClick={this.loginAnchor}>Anchor</button>
        </SweetAlert>
      </ul>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.authorizedUser.user,
    wax: state.authorizedUser.wax,
    socket_user: state.socket.socket_user,
    socket_connected: state.socket.socket_connected,
    got_nft_list:state.nft.got_nft_list
  }
}

export default withUAL(connect(mapStateToProps, {logout, waxLogin, oreLogin, anchorLogin, wombatLogin, checkIfLoggedIn})(NavbarUser))
